// Importing `notifyJoyfulExtension` keeps the `Window.chrome` global
// augmentation defined in that module attached to this file's compilation,
// rather than redeclaring (and risking a divergent) shape here.
import '@/features/auth/utils/notifyExtension'

const SIDECAR_SOURCE = 'joyful-sidecar'
const DEFAULT_PING_TIMEOUT_MS = 500

// Pings the Joyful sidecar Chrome extension and resolves `true` only when a
// well-formed pong arrives within the timeout. Outside Chromium, when the
// extension isn't installed, or when `externally_connectable` rejects the
// origin, resolves `false`. Never rejects.
export function detectJoyfulSidecarExtension(
  extensionId: string,
  timeoutMs: number = DEFAULT_PING_TIMEOUT_MS,
): Promise<boolean> {
  return new Promise((resolve) => {
    const runtime = window.chrome?.runtime
    if (!runtime) {
      resolve(false)
      return
    }

    let isSettled = false
    const settle = (installed: boolean) => {
      if (isSettled) {
        return
      }

      isSettled = true
      resolve(installed)
    }

    const timeoutHandle = window.setTimeout(() => {
      settle(false)
    }, timeoutMs)

    try {
      runtime.sendMessage(extensionId, { type: 'ping' }, (response) => {
        window.clearTimeout(timeoutHandle)
        // Reading lastError prevents Chrome from logging when the extension
        // is absent or the origin isn't on externally_connectable.matches.
        if (runtime.lastError !== undefined) {
          settle(false)
          return
        }

        const isSidecarPong =
          response?.ok === true && response.source === SIDECAR_SOURCE
        settle(isSidecarPong)
      })
    } catch {
      window.clearTimeout(timeoutHandle)
      settle(false)
    }
  })
}
